import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SavedTimeState {
  closeSavedTime: (trialId: string) => void;
  closedBanners: {
    [trialId: string]: boolean;
  };
}

export const useSavedTimeStore = create<SavedTimeState>()(
  persist(
    (set) => ({
      closedBanners: {},
      closeSavedTime: (trialId: string) => {
        set(({ closedBanners }) => ({
          closedBanners: {
            ...closedBanners,
            [trialId]: true,
          },
        }));
      },
    }),

    {
      name: 'saved-time',
    },
  ),
);

export const clearSavedTimeStore = () => useSavedTimeStore.persist.clearStorage();
